import { render, staticRenderFns } from "./VeterinaryPatientData.vue?vue&type=template&id=6a8a13ce"
import script from "./VeterinaryPatientData.vue?vue&type=script&lang=js"
export * from "./VeterinaryPatientData.vue?vue&type=script&lang=js"
import style0 from "./VeterinaryPatientData.vue?vue&type=style&index=0&id=6a8a13ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports